// extracted by mini-css-extract-plugin
export var item = "loading-module--item--37f9b";
export var loading = "loading-module--loading--dc623";
export var main = "loading-module--main--897f2";